<!-- 示例页面 -->
<template>
  <div class="">
    <div class="p16 align-items">
      <div>店员管理</div>
      <div>
        <el-button type="primary" class="small-btn" @click="detailsPage()"
          v-perm="{ key: 'staffManage', value: 'staffManage:add' }">新增店员</el-button>
        <el-button type="primary" class="small-btn" @click="changRemove('formal')"
          v-perm="{ key: 'staffManage', value: 'staffManage:transfer' }">他店调入</el-button>
        <el-button type="primary" class="small-btn" @click="changRemove('temporary')"
          v-perm="{ key: 'staffManage', value: 'staffManage:tempHelp' }">临时帮忙</el-button>
        <el-button type="primary" class="small-btn" @click="changRemove('recall')"
          v-perm="{ key: 'staffManage', value: 'staffManage:transferBack' }">店员调回</el-button>
        <el-button type="primary" class="small-btn" @click="updateRecord()"
          v-perm="{ key: 'staffManage', value: 'staffManage:updateRecord' }">修改记录</el-button>
      </div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <el-tabs v-model="activeIndex" @tab-click="handleClick">
          <el-tab-pane label="正常账号" name="one"></el-tab-pane>
          <el-tab-pane label="禁用账号" name="two"></el-tab-pane>
        </el-tabs>
        <div class="tops-between" v-show="activeIndex == 'two'"
          v-perm="{ key: 'staffManage', value: 'staffManage:list' }">
          <el-select v-model="query.staffStatus" class="mr10" style="font-size: 16px;" placeholder="请选择"
            @change="staffStatusChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- v-perm="{ key: 'staffManage', value: 'staffManage:list' }" -->
        <div class="member-content-box" v-perm="{ key: 'staffManage', value: 'staffManage:list' }">
          <el-table :data="list" :max-height="height - 280" header-cell-class-name="table_header_bgcolor">
            <el-table-column :prop="index" :align="item.align" :label="item.label" :width="item.width"
              :min-width="item.minWidth" :show-overflow-tooltip="false" v-for="(item, index) in columns" :key="index">
              <template slot-scope="scope">
                <div v-if="index == 'headImgUrl'">
                  <img :src="scope.row.headImgUrl ? scope.row.headImgUrl : headImg" alt="" class="staffImg">
                </div>
                <div v-else>{{ Boolean(item.formatDay) ? formatDay(scope.row[index]) : scope.row[index] }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="amt" label="操作" align="left" width="260" fixed="right">
              <template slot-scope="scope">
                <!-- v-perm="{ key: 'staffManage', value: 'staffManage:updateInfo' }" -->
                <el-link type="primary" @click="detailsPage(scope.row)" class="mr10"
                  v-perm="{ key: 'staffManage', value: 'staffManage:updateInfo' }">修改资料</el-link>
                <el-link type="primary" class="mr10" @click="detailsPage(scope.row, 'isResubmit')"
                  v-if="scope.row.auditStatus == 'refuse'">重新提交入职</el-link>
                <span v-if="scope.row.auditStatus == 'pass'" class="mr10">
                  <el-link type="primary" class="mr10" @click="repairPage(scope.row)">档案管理</el-link>
                  <el-link type="primary" class="mr10"
                    v-if="query.accountStatus != 'quit' && !userInfo.shopBizConfig.yuanyuanFlag"
                    @click="updateStatus(scope.row, scope.$index)">{{ scope.row.accountStatus == 'enable' ? '禁用' : '启用'
                    }}</el-link>
                  <el-link type="primary" class="mr10" @click="companyQuit(scope.row)">离职申请</el-link>
                </span>
                <el-link type="primary" v-if="userInfo.manageModel == 'group' && userInfo.shopBizConfig.yuanyuanFlag" @click="skipSupplementtary(scope.row)">补充资料</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- <serve-set ref="serveSetForm"></serve-set> -->
    <add-edit ref="addEditForm" @handleChange="changeAddEdit"></add-edit>
    <detail-edit ref="detailEditForm" @handleChange="changedetailEdit"></detail-edit>
    <staff-remove ref="staffRemove" @change="changeRemove"></staff-remove>
    <company-quit ref="companyQuitForm" @change="companyQuitAudit"></company-quit>
    <thirdPartyEdit ref="thirdPartyEditForm" @handleChange="changeAddEdit"></thirdPartyEdit>
    <el-dialog class="el-dialogs" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%" append-to-body
      title="禁用原因" center>
      <div class="divCenter">
        <el-select v-model="form.disableReason" placeholder="禁用原因" clearable size="small">
          <el-option v-for="(item, index) in ressonList" :key="index" :label="item.desc" :value="item.value"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeClose">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
    <add-supplementary-info ref="addSupplementaryInfoRef"></add-supplementary-info>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import addSupplementaryInfo from "./addSupplementaryInfo.vue";
import addEdit from "./edit";
import thirdPartyEdit from "./thirdPartyEdit.vue";
import detailEdit from "./detail";
import cardEdit from "./idCardEdit";
import staffRemove from "./staffRemove";
import companyQuit from "./companyQuit";
import config from "./config/columns";


export default {
  data() {
    return {
      firstShow: false,
      options: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'enable',
          label: '在职'
        },
        {
          value: 'disable',
          label: '禁用'
        },
        {
          value: 'quit',
          label: '离职'
        },
        {
          value: 'leave',
          label: '请假'
        },
        {
          value: 'publicLeave',
          label: '公休'
        },
        {
          value: 'transfer',
          label: '调动'
        }
      ],
      ressonList: [],
      height: this.$store.getters.MainHeight,
      form: {},
      dialogVisible: false,
      columns: config.noColumns,
      list: [],
      headImg: require("../../../assets/images/headerImg.png"),
      query: {
        size: 100,
        shopId: localStorage.getItem("shopIds")
          ? localStorage.getItem("shopIds")
          : "",
        accountStatus: 'enable',
        staffStatus: ""
      },
      url: this.$url.companyShopStaff.listByAccountStatus,
      activeIndex: 'one',
      userInfo: {}
    };
  },
  mixins: [minxin],
  components: {
    addEdit,
    detailEdit,
    cardEdit,
    staffRemove,
    companyQuit,
    thirdPartyEdit,
    addSupplementaryInfo
  },

  created() {
    this.userInfo = this.$store.getters.ShopInfo;
    this.getReason();
    console.log(this.userInfo);
    this.staffList();

  },
  watch: {
    "$store.getters.SwitchShopflag": function (old) {
      this.staffList();
    },
  },
  methods: {
    staffStatusChange(value) {
      this.query.start = 1;
      this.staffList();
    },
    staffList() {
      this.$api.get(this.url, this.query).then(res => {
        this.list = res;
        for (let i in this.list) {
          this.list[i].oxCtime = this.formatDate(this.list[i].oxCtime);
        }
      })
        .catch(error => {
          console.log("error: ", error);
        });
    },
    getReason() {
      // 获取禁用原因
      this.$api.get(this.$url.companyStaff.getDisableReason, this.query).then(res => {
        this.ressonList = res;
      }).catch(error => {
        console.log("error: ", error);
      });
    },
    // 离职申请
    companyQuit(row) {
      row.source = 'staffManage';
      this.$refs["companyQuitForm"].$emit("set", row);
    },
    // 离职申请回调
    companyQuitAudit(org) {
      if (org) {
        this.staffList();
      }
    },
    //管理分类
    setClassify() {
      this.$refs["serveSetForm"].$emit("set", true);
    },
    changeAddEdit() {
      this.staffList();
    },
    changedetailEdit() { },
    changeRemove(org) {
      console.log(org)
      if (org) {
        this.staffList();
      }
    },
    repairPage(row) {
      this.$router.push(`/manage/repairRecord/${row.id}`);
    },
    detailsPage(row, type) {
      if (row == undefined) {
        if (!this.userInfo.shopBizConfig.easyStaffFlag) {
          // 复杂店员
          this.$refs.addEditForm.init({ id: 0 })
        } else {
          // 简易店员
          this.$refs["thirdPartyEditForm"].$emit("set", { id: 0 });
          // this.$router.push("/data/staffManage/thirdPartyEdit");
        }
      } else {
        if (type) { // 重新入职
          if (!this.userInfo.shopBizConfig.easyStaffFlag) {
            // 复杂店员
            this.$refs.addEditForm.init({ id: row.id, isResubmit: true })
          } else {
            // 简易店员
            this.$refs["thirdPartyEditForm"].$emit("set", { id: row.id, isResubmit: true });
          }
        } else { // 编辑
          if (!this.userInfo.shopBizConfig.easyStaffFlag) { 
            // 复杂店员
            this.$refs.addEditForm.init({ id: row.id})
          } else {
            // 简易店员
            this.$refs["thirdPartyEditForm"].$emit("set", { id: row.id });
          }
        }
      }
    },
    updateRecord() {
      this.$router.push(`/manage/staffManage/updateRecord`);
    },
    // 调度
    changRemove(value) {
      this.$refs["staffRemove"].$emit("set", value);
    },
    details(row) {
      this.$refs["detailEditForm"].$emit("set", row.id);
    },
    updateStatus(row, index) {
      console.log(row);
      if (row.accountStatus == "disable" || row.accountStatus == "quit") {
        this.$confirm("确定要启用店员状态？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }).then(() => {
          this.$api.get(this.$url.companyShopStaff.updateStatus, {
            id: row.id,
            status: row.accountStatus == "enable" ? "disable" : "enable"
          }).then(res => {
            if (res) {
              this.staffList();
              this.$message.success("操作成功");
            }
          });
        })
          .catch(() => { });
      } else {
        this.dialogVisible = true;
        this.form = JSON.parse(JSON.stringify(row));
      }
    },
    changeClose() {
      this.dialogVisible = false;
      this.form = {};
    },
    save() {
      if (!this.form.disableReason) {
        return this.$message.error("请选择禁用原因")
      }
      this.$confirm('确定要禁用店员状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.get(this.$url.companyShopStaff.updateStatus, {
          id: this.form.id,
          disableReason: this.form.disableReason,
          status: this.form.status == "enable" ? "disable" : "enable"
        }).then(res => {
          if (res) {
            this.staffList();
            this.dialogVisible = false;
            this.form = {};
            this.$message.success("操作成功");
          }
        }).catch(() => { });
      }).catch(() => {

      });
    },
    handleClick() {
      console.log(this.activeIndex);
      if (this.activeIndex == 'one') {
        this.query.staffStatus = "";
        if (this.userInfo.shopBizConfig.yuanyuanFlag) {
          this.columns = config.noColumns;
        } else {
          this.columns = config.columns;
        }
        this.query.accountStatus = "enable";
      } else {
        if (this.userInfo.shopBizConfig.yuanyuanFlag) {
          this.columns = config.noDisableColumns;
        } else {
          this.columns = config.disableColumns;
        }
        this.query.accountStatus = "disable";
      }
      this.staffList();
    },
    skipSupplementtary (row) { 
      this.$api.get(this.$url.companyShopStaff.get, {
        id: row.id
      }).then(res => {
        if (res) {
          res.healthCertificateHandleTime = this.formatDate(res.healthCertificateHandleTime)
          if (res.healthCertificateImgUrl) {
            if (res.healthCertificateImgUrl.indexOf("?") > -1) {
              let arr = res.healthCertificateImgUrl.split("?")
              res.healthCertificateImgUrl = arr[0]
            }
          }
          res.healthTime = this.formatDate(res.healthTime)
          res.isDetail = true
          this.$refs.addSupplementaryInfoRef.open(res)
        }
      })
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.staffImg {
  object-fit: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.mains-content {
  height: calc(100% - 72px);
  padding: 0 16px 0;
  background: #fff;
  border-radius: 10px;

  .tops-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tops-title {
    width: 100%;
    box-sizing: border-box;

    p {
      font-size: 18px;
      font-weight: 500;
      height: 60px;
      line-height: 60px;

      span {
        color: @blue;
      }
    }

    .add-btns {
      width: 100px;
      height: 32px;
    }
  }

  .member-content-box {
    padding: 16px 0;
    // margin-top: 10px;
  }
}

/deep/ .el-input__inner {
  font-size: 16px;
}
</style>

